export const ADVISER_OWNER_EMAILS = [
  'dennisgeoffreyjensen@gmail.com',
  'support@supercalcpro.com.au',
];

export function isAdviserOwnerEmail(email) {
  return ADVISER_OWNER_EMAILS.includes(String(email || '').trim().toLowerCase());
}

export function isOwnerAdviserUnlock() {
  if (typeof window === 'undefined') return false;
  return (
    localStorage.getItem('subscription_id') === 'owner-adviser' ||
    localStorage.getItem('adviser_role') === 'owner'
  );
}
